// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-view-footer {
	height: 80px;
	display: flex;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	color: #696969;
	justify-content: space-between;
	align-items: center;
	padding: 0px 12px 0px 34px;
	flex-grow: 0;
	flex-shrink: 0;
	min-width: 860px;
}

.view-footer-words-page {
	font-family: 'Segoe UI', sans-serif;
	font-weight: 400;
	font-style: Regular;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0px;
}

.view-footer-copyright-page {
	font-family: 'Segoe UI', sans-serif;
	line-height: 16px;
	color: #696969;
	flex: 1 1;
	text-align: left;
}

.view-footer-words-page {
	font-family:
		Segoe UI,
		sans-serif;
	font-weight: 400;
	font-style: Regular;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0px;
	text-align: right;
}

.view-footer-words-underline-page:hover {
	color: #000f52;
}

.view-footer-words-margin a {
	color: #696969;
}

.view-footer-words-hover-page {
	cursor: pointer;
	color: #696969;
	padding-left: 16px;
}

.view-footer-words-hover-page a:hover {
	color: #3b3b3b;
}

.view-footer-words-hover-pgae:hover {
	color: #3b3b3b;
}

.view-footer-line {
	margin: 0 6px;
}

.view-footer-copyright-page img {
	vertical-align: middle;
	margin: 0 4px;
	margin-top: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/index.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,8BAA8B;CAC9B,mBAAmB;CACnB,0BAA0B;CAC1B,YAAY;CACZ,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;CACnC,iBAAiB;CACjB,cAAc;CACd,SAAO;CACP,gBAAgB;AACjB;;AAEA;CACC;;YAEW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,gBAAgB;AACjB","sourcesContent":[".page-view-footer {\n\theight: 80px;\n\tdisplay: flex;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tcolor: #696969;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0px 12px 0px 34px;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\tmin-width: 860px;\n}\n\n.view-footer-words-page {\n\tfont-family: 'Segoe UI', sans-serif;\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n}\n\n.view-footer-copyright-page {\n\tfont-family: 'Segoe UI', sans-serif;\n\tline-height: 16px;\n\tcolor: #696969;\n\tflex: 1;\n\ttext-align: left;\n}\n\n.view-footer-words-page {\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif;\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tfont-size: 12px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n\ttext-align: right;\n}\n\n.view-footer-words-underline-page:hover {\n\tcolor: #000f52;\n}\n\n.view-footer-words-margin a {\n\tcolor: #696969;\n}\n\n.view-footer-words-hover-page {\n\tcursor: pointer;\n\tcolor: #696969;\n\tpadding-left: 16px;\n}\n\n.view-footer-words-hover-page a:hover {\n\tcolor: #3b3b3b;\n}\n\n.view-footer-words-hover-pgae:hover {\n\tcolor: #3b3b3b;\n}\n\n.view-footer-line {\n\tmargin: 0 6px;\n}\n\n.view-footer-copyright-page img {\n\tvertical-align: middle;\n\tmargin: 0 4px;\n\tmargin-top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
